import { Directive, Input, Renderer2, ElementRef, SimpleChanges, OnChanges, HostListener, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EnvSetting } from '../utils/env-setting';
import { GlobalSetting } from '../common-services/global-setting.service';
import { DataService } from '../services/data.service';

@Directive({
    selector: 'img[af-image]'
})
export class AfImageDirective implements OnChanges, OnInit {
    @Input('data-code') imgCode: string;
    @Input('data-src') imgSrc: string | null = null;
    @Input('data-fallback') fallback: string | null = null;

    private readonly _noImage = '/assets/no-image-icon.png';
    private readonly _loading = '/assets/images/loading.svg';

    constructor(private readonly dataService: DataService,
        private readonly globalSetting: GlobalSetting,
        private readonly elementRef: ElementRef,
        private readonly renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document) {
    }
    ngOnInit(): void {
        this.elementRef.nativeElement.src = this._loading;
        this.renderer.setAttribute(this.elementRef.nativeElement, 'img-code', this.imgCode);
        this.loadImage();
    }

    @HostListener('error')
    loadFallback() {
        this.elementRef.nativeElement.src = this.fallback ?? this._noImage;
    }

    ngOnChanges(_changes: SimpleChanges): void {
        this.elementRef.nativeElement.src = this._loading;
        this.loadImage();
    }

    loadImage() {
        const element = this.elementRef.nativeElement;
        if (!element) {
            return;
        }
        if (this.imgCode) {
            const _imgCode = this.imgCode;
            const existImg = this.globalSetting.cacheImages.find(x => x.imgCode == _imgCode);
            if (existImg?.imgData) {
                this.reloadImage(_imgCode, existImg.imgData);
            }
            else if (existImg?.processed) {
                this.reloadImage(_imgCode, this._noImage);
            }
            else if (_imgCode && !existImg) {
                this.globalSetting.cacheImages.push({ imgCode: _imgCode, imgData: '', processed: false });
                this.dataService.Get(`${EnvSetting.VIEW_IMAGE_API_URL}`, _imgCode).subscribe((res: any) => {
                    const b64 = res ? res : this._noImage;
                    this.globalSetting.cacheImages.filter(x => x.imgCode == _imgCode).forEach(el => {
                        el.imgData = b64;
                        el.processed = true;
                    });
                    this.reloadImage(_imgCode, b64);
                }, (_err) => {
                    this.reloadImage(_imgCode, this._noImage);
                });
            }
            else {
                this.reloadImage(_imgCode, this._loading);
            }
        }
        else {
            this.renderer.setAttribute(element, 'src', this.imgSrc ?? this._noImage);
        }
    }
    reloadImage(imgCode: string, imgData: string) {
        const images = this.document.querySelectorAll(`[img-code="${imgCode}"]`);
        images.forEach((img) => {
            this.renderer.setAttribute(img, 'src', imgData);
            if (imgData == this._loading) {
                img.classList.add('img-loading');
            }
            else {
                img.classList.remove('img-loading');
            }
        });
    }
}